import { useTranslation } from "react-i18next";

const useTranslate = () => {
  const { t, ready, i18n } = useTranslation("translation", {
    useSuspense: false,
  });

  return (
    key: string | null,
    values?: Record<string, string | number>,
  ): string => {
    if (!key) {
      return "";
    }
    if (!ready) {
      return key;
    } // Пока переводы не загрузились, возвращаем ключ
    const result = t(key, { defaultValue: key, ...values }); // Возвращаем перевод или ключ, если перевода нет
    if ((result === "" || result === key) && i18n.language !== "en") {
      return i18n.t(key, { lng: "en", defaultValue: key, ...values });
    }
    return result;
  };
};

export default useTranslate;
